// Basis-URL der eigentlichen Software (Login/Registrierung/Dashboard).
// Client + Server laufen unter app.martialverse.de, diese Website unter
// martialverse.de – beides eigenständige Deployments. Für lokale Tests
// gegen eine andere URL kann REACT_APP_APP_URL in einer .env überschrieben
// werden.
export const APP_URL = process.env.REACT_APP_APP_URL || "https://app.martialverse.de";

export const LOGIN_URL = `${APP_URL}/login`;
export const REGISTER_URL = `${APP_URL}/register`;
